<template>
  <div class="portrait-collage">
    <img
      :src="generatedPortraitUrl"
      alt="Filip Hric"
      width="1024"
      height="1024"
      class="collage-portrait collage-portrait-generated"
      fetchpriority="high"
    />
    <div class="collage-note">
      <span>I'm Filip.</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { homepageHeroImage } from '~/helpers/editorialImages'

const { url: generatedPortraitUrl } = useCldImageUrl({
  options: {
    src: homepageHeroImage,
    removeBackground: true,
    width: 1024,
    height: 1024
  }
})
</script>

<style scoped>
.collage-portrait-generated {
  width: 100%;
  height: 100%;
  left: 0;
  bottom: 0;
  filter: none;
}
</style>
